export class ProfileModel {
    profileDto: ProfileDto = new ProfileDto();
    addressDto: addressDto[] = [];
  }
  
  export class ProfileDto {
    title: string = '';
    firstName: string = '';
    lastName: string = '';
    middleName: string = '';
    fullName: string = '';
    ageStr: string = '';
    birthDate: string = '';
    cityName: string = '';
    countryName: string = '';
    districtName: string = '';
    domicileDistrict: string = '';
    fatherCnic: string = '';
    fatherName: string = '';
    fatherStatus: string = '';
    cellPhone: string = '';
    email:string = '';
    
  
  }
  
  export class addressDto {
    address: any = '';
    addressTypeCode: number = null;
    cityName: any = '';
    countryName: any = '';
    domicileName  : any = '';
    provinceName: any = '';
    zipCode: any = '';
  }

  export class contactDtos {
    contactType: any = '';
    contactValue: any = '';
    countryDialingCode: any = '';
    countryName: any = '';
  }

  export class EducationDtos {
    uniName: any = '';
    countryValue: any = '';
    exactDegreeName: boolean;
    qualificationLevel: any = '';
    campus: any = '';
    department: any = '';
    degreeObtainedBy: any = '';
    discipline: boolean;
    startDate: any = '';
    endDate: boolean;
    major: boolean;
    modeOfStudy: any = '';
    researchTitle: any = '';
    rollNo: any = '';
    sessionType: any = '';
  }


  export class DesDegreeDtos {
    amount: any = '';
    applicantNameOnDegree: any = '';
    certificateInEnglish: any = '';
    exactDegreeName: any = '';
    isAnnual: any = '';;
    isProvisional: any = '';
    linkAvailable: any = '';
    noOfStudyMonths: any = '';
    status: any = '';
    uniNameOnDegree: any = '';
    uniVerificationAvailable: any = '';
    universityEmail: any = '';
  }